import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ensureArray } from '../../../utils/validateResponseApi';
import { callApi } from '../../../services/api.service';

import { isNotEmptyObject, safeParseJSON } from '../../../utils/jsonValidator';
import { useDataAuth } from '../../../hooks/useDataAuth';
import useExcelExport from '../../../hooks/useExcelExport';
import { useCompanyConfiguration } from '../../../hooks/useCompanyConfiguration';

export default function useManageCharts(conf) {
    const chartRefs = useRef({});
    const navigate = useNavigate();
    const location = useLocation();
    const [{ userSession }] = useDataAuth();
    const { exportToExcel } = useExcelExport();
    const [infoAction, setInfoAction] = useState({});
    const [filters, setfilter] = useState({});
    const [openDialogCompany, setOpenDialogCompany] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(false);
    const [idCompany, setIdCompany] = useState(null);
    const [configuration, setConfiguration] = useState({
        charts: [],
        buttons: [],
    });

    const {
        selectedCompanyId,
        startViewAs,
        endViewAs
    } = useCompanyConfiguration();

    const setfil = (obj) => setfilter(prev => {
        if (obj == null || typeof obj !== 'object') return { ...prev };
        if (Object.prototype.hasOwnProperty.call(obj, 'id_company')) {
            return { ...prev, ...obj };
        }

        const userFieldIds = ensureArray(configuration.buttons)
            .filter((button) => button?.type === 'filter')
            .flatMap((button) => ensureArray(button.filter).map((field) => field.id));

        if (userFieldIds.length === 0) return { ...prev, ...obj };

        const next = { ...prev };
        userFieldIds.forEach((id) => {
            delete next[id];
        });
        return { ...next, ...obj };
    });
    const getChartRef = useCallback((idx) => chartRefs.current[idx] ??= React.createRef(), []);
    const handleExport = (idx) => {
        const ref = chartRefs.current[idx];
        if (ref && ref.current && ref.current.exportChartData) {
            ref.current.exportChartData();
        } else {
            console.error(`Referencia o función de exportación no encontrada para el índice ${idx}`);
        }
    };

    const parseConfiguration = (parsed) => {
        return {
            charts: ensureArray(parsed?.charts),
            buttons: ensureArray(parsed?.button),
            ...parsed
        };
    };

    const handleConfirmAction = useCallback(async (dtoCompany, globalCompany = true) => {
        startViewAs(dtoCompany, globalCompany);
        setIdCompany(dtoCompany.id_company);
        setfil({
            "id_company": {
                "value": dtoCompany.id_company,
                "operator": "=",
                "type": "string"
            }
        });
        setOpenDialogCompany(false);
    }, [startViewAs]);

    const handleSelectComapny = (arrayComapnys) => {
        const dto = arrayComapnys.find(p => p.id_company === selectedCompanyId) || {};
        if (configuration?.select_company && !isNotEmptyObject(dto) && arrayComapnys.length !== 1) {
            setOpenDialogCompany(true);
            setLoading(false);
            return false;
        }

        if (arrayComapnys.length === 1) {
            handleConfirmAction(arrayComapnys[0], false);
        } else {
            const ids = arrayComapnys.map(cp => cp.id_company);
            setfil({
                "id_company": {
                    "value": ids,
                    "operator": "IN",
                    "type": "string"
                }
            });
            setOpenDialogCompany(false);
        }
        setLoading(false);
    }

    const fetchCompanysByIdUserAction = async (id_user_action) => {
        setLoading(true);
        try {
            if (companies.length === 0) {
                const response = await callApi(
                    'company_select',
                    'SELECT_COMPANIES_BY_USER_ACTION',
                    { id_user_action },
                    userSession.token
                );
                const compns = ensureArray(response.data);
                setCompanies(compns);
                handleSelectComapny(compns);
            } else {
                handleSelectComapny(companies);
            }
        } catch (e) {
            console.error(e.message);
        }
    }

    useEffect(() => {
        if (selectedCompanyId !== idCompany && idCompany !== null) {
            fetchCompanysByIdUserAction(infoAction.id_user_action?.toString());
        }
    }, [selectedCompanyId])

    useEffect(() => {
        const config = location.state?.config || conf?.config;
        if (config) {
            setInfoAction(config);
            const configuration = parseConfiguration(safeParseJSON(config.configuration));
            setConfiguration(configuration);
            fetchCompanysByIdUserAction(config?.id_user_action?.toString());
        }
    }, [conf, conf?.config, location.state?.config]);

    const Cancel = () => {
        setOpenDialogCompany(false);
        navigate(-1);
        endViewAs();
    };

    return ({
        infoAction,
        configuration,
        filters,
        companies,
        loading,
        openDialogCompany,
        handleConfirmAction,
        Cancel,
        setfil,
        getChartRef,
        handleExport,
        exportToExcel
    })
}
